import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-386661282__Layer_1",
  viewBox: "0 0 333.71 281.72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M332.7 68.82h-6.07v-34.4h6.07v34.4Zm0 89.28h-6.07v-34.4h6.07v34.4Zm0 89.34h-6.07v-34.4h6.07v34.4ZM8.09 8.09h59.6v95.63H8.09V8.09Zm92.16 34.23H75.78v-3.74h24.47v3.74Zm1.01-4.22c0-1.7 1.38-3.08 3.08-3.08s3.08 1.38 3.08 3.08v40.78c0 1.7-1.38 3.08-3.08 3.08s-3.08-1.38-3.08-3.08V38.1Zm-9.93 65.62 11.43-21.07c.34.14.7.22 1.07.27v20.8h-12.5Zm10.07-22.01c.15.16.32.29.49.42l-11.71 21.59H76.5l24.9-22.01Zm-25.62-3.8 24.47-1.29v1.94l-24.47 4.61v-5.25Zm24.6 1.94-24.6 11.32v-6.98l24.54-4.62c.02.1.04.19.06.28m.42 1.04L75.78 103V92.29l24.97-11.49s.03.06.05.09M75.78 43.33h24.47v3.74H75.78v-3.74Zm0 4.75h24.47v3.74H75.78v-3.74Zm0 4.75h24.47v3.74H75.78v-3.74Zm0 4.75h24.47v3.74H75.78v-3.74Zm0 4.75h24.47v3.74H75.78v-3.74Zm0 4.75h24.47v3.74H75.78v-3.74Zm0 4.75h24.47v3.76l-24.47 1.29v-5.06ZM126.34 0v8.09h16.97V38.6h8.09V8.09h94.08v11.22h7.33v-5.04l4.43-3.51h12.21l4.43 3.51v5.04h7.33V8.09h44.41v265.54H151.41V244.5h-8.09v29.13H8.09V111.81h105.82v-8.09h-9.06v-20.8c2.01-.25 3.58-1.96 3.58-4.04V38.1c0-2.25-1.83-4.09-4.09-4.09-2.07 0-3.77 1.55-4.03 3.56H75.79V8.09h16.15V0H0v281.72h333.71V0H126.34Z",
  class: "i-386661282__cls-1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M151.4 210.1V73h-8.09v30.72h-3.6v8.09h3.6v98.29h8.09z",
  class: "i-386661282__cls-1"
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [
          _createTextVNode(".i-386661282__cls-1{stroke-width:0}")
        ]),
        _: 1
      }))
    ]),
    _hoisted_2,
    _hoisted_3
  ]))
}
export default { render: render }